import {
  GET_REQUESTS,
  GET_REQUESTS_SUCCESS,
  GET_REQUESTS_FAILURE,
  ADD_REQUEST,
  ADD_REQUEST_SUCCESS,
  ADD_REQUEST_FAILURE,
  DELETE_REQUEST,
  DELETE_REQUEST_SUCCESS,
  DELETE_REQUEST_FAILURE,
  GET_SINGLE_REQUEST,
  GET_SINGLE_REQUEST_SUCCESS,
  GET_SINGLE_REQUEST_FAILURE,
} from "./actionTypes";

const initialState = {
  requests: [],
  loading: false,
  error: "",
  singleRequest: {},
};

const brands = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUESTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_REQUESTS_SUCCESS:
      state = {
        ...state,
        loading: false,
        requests: action.payload.requests,
      };
      break;
    case GET_REQUESTS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case GET_SINGLE_REQUEST_SUCCESS:
      state = {
        ...state,
        loading: false,
        singleRequest: action.payload.reequest,
      };
      break;

    case GET_SINGLE_REQUEST_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
        singleRequest: {},
      };
      break;

    case ADD_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ADD_REQUEST_SUCCESS:
      state = {
        ...state,
        loading: false,
        requests: action.payload.requests,
      };
      break;
    case ADD_REQUEST_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case DELETE_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_REQUEST_SUCCESS:
      const countriesAfterDeleteing = [
        ...state?.requests?.filter((request) => request?.id !== action.payload),
      ];
      state = {
        ...state,
        loading: false,
        requests: countriesAfterDeleteing,
      };
      break;
    case DELETE_REQUEST_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default brands;
